/**
 * Firebase Configuration
 *
 * IMPORTANT: This file contains sensitive information and should NOT be committed to Git.
 * It's already added to .gitignore
 *
 * Replace these values with your actual Firebase configuration from Firebase Console.
 */

export const firebaseConfig = {
  apiKey: "AIzaSyCNRIFZpw1Zn_Sa_R3XLr0kmfMnwxBxkLA",
  authDomain: "padelhub-173a2.firebaseapp.com",
  projectId: "padelhub-173a2",
  storageBucket: "padelhub-173a2.firebasestorage.app",
  messagingSenderId: "552544922181",
  appId: "1:552544922181:web:e2d4d4c975935bb357912c",
  measurementId: "G-242G8XP9K5"
};

export const vapidKey = "BA6orU44S8egZ6F2V-6RjLIKpsjLCsudMEVRG73On4euIG885XdYUbbIZbeFbx8LvnmDerWrbdqNJ031UyWaj7U";
